import { BigNumber } from '@ethersproject/bignumber';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ethers } from 'ethers';
import { PropsBase } from '../model/props-base';

export interface CryptoValueProps extends PropsBase {
    value?: number | BigNumber;
}

export const CryptoValue = ((props: CryptoValueProps) => {
    const value = props.value || 0;
    const display = (value instanceof BigNumber)
        ? parseFloat(ethers.utils.formatEther(value))
        : value;

    return (
        <span {...props}>
            <FontAwesomeIcon className="text-muted" size="sm" icon={['fab', 'ethereum']} />
            <span className="ms-2">{display.toFixed(6)}</span>
        </span>
    );
});